<template>
  <mt-popup v-model="moduleState.editText" :modal=false position="right" class="edit-main">
    <app-header v-bind="headerConfig" ref="header"></app-header>
    <main class="edit-wrapper" @click.self="addfocus">
      <textarea v-model.trim="conf.data" :placeholder="conf.slogan" ref="editBox" :style="{height: textHeight + 'px'}"></textarea>
    </main>
    <a href="javascript:;" class="finish-btn" @click.stop="close">确认</a>
  </mt-popup>
</template>

<script>
  import {Toast} from 'mint-ui';
  import {mapState} from 'vuex';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: "edit_text",
    props: ['type'],
    components: {
      'app-header': AppHeader
    },
    computed: {
      watchCut() {
        return this.moduleState.editText
      },
      watchEditText() {
        return this.conf.data;
      },
      ...mapState(['moduleState'])
    },
    data() {
      return {
        headerConfig: {
          title: '',
          isStoryMenu: false,
          backNote: '返回',
          backPage: '',
          closeModule: ComponentName.EDIT_TEXT
        },
        textHeight: 0,
        conf: {
          title: '',
          data: '',
          slogan: '',
          callback: {}
        }
      }
    },
    methods: {
      close() {
        this.conf.callback && this.conf.callback();
        setTimeout(function () {
          Methods.cutComponent([ComponentName.EDIT_TEXT], false)
        }, 400);
        Methods.checkChapterHash(114);
      },
      addfocus() {
        this.$refs.editBox.focus();
        Methods.checkChapterHash(113);
      },
      autoHeight() {
        let elem = this.$refs.editBox;

        this.textHeight = 0;
        elem.scrollTop = 0;
        this.$nextTick(function () {
          this.textHeight = elem.scrollHeight;
        })
      },
      setConf() {
        var _this = this;

        switch (this.type) {
          case 'name':
            this.conf = {
              title: '编辑作品名',
              data: store.state.storyName,
              slogan: '',
              callback: function() {
                if (_this.conf.data === '') {
                  _this.conf.data = store.state.storyName;
                  return Toast({
                    message: '作品名不能为空',
                    duration: 2000
                  });
                } else {
                  store.state.storyName = _this.conf.data;
                }
              }
            };
            break;
          case 'desc':
            this.conf = {
              title: '编辑简介',
              data: Methods.storyDesc(),
              slogan: '写个简介，介绍下你的作品~',
              callback: function() {
                Middle.MiddleData.setProjectDesc(_this.conf.data);
              }
            };
            break;
        }
      }
    },
    mounted() {
      this.$nextTick(function () {
        this.autoHeight();
      });
    },
    watch: {
      watchCut(newVal) {
        if (newVal) {
          this.setConf();
        }
      },
      watchEditText(newVal) {
        if (this.type === 'name') {
          let _store = store.state;

          this.conf.data = newVal.replace(_store.nameReg, '').replace(_store.emoReg, "");
        }

        this.autoHeight();
      }
    },

  }
</script>

<style scoped>
  @import "../style/css/edit_story_text.css";
</style>



// WEBPACK FOOTER //
// src/components/edit_text.vue